// A tiny pub/sub bridge so a page (currently the Inbox) can offer contextual actions to the
// global command palette without wiring cross-page props. The page publishes actions that
// each carry their own run() closure; the palette renders them and calls run() on select.
//
// Each action: { id, label, icon (lucide component), run: () => void, keywords?: string[] }

let _actions = [];
const listeners = new Set();

export function setCommandActions(actions) {
  _actions = Array.isArray(actions) ? actions : [];
  listeners.forEach((fn) => fn(_actions));
}

export function clearCommandActions() {
  setCommandActions([]);
}

export function getCommandActions() {
  return _actions;
}

export function subscribeCommandActions(fn) {
  listeners.add(fn);
  fn(_actions);
  return () => listeners.delete(fn);
}
